import { RegistratioJourney } from "../../../../../shared/model/registration-journey";

export class ParseContaIonData {
    public static parse(data: RegistratioJourney) {

        data.data.personalData.cityOfBirth = data.data.personalData.cityOfBirth ?
            data.data.personalData.cityOfBirth : undefined;
        data.data.personalData.cityOfBirthName = data.data.personalData.cityOfBirthName ?
            data.data.personalData.cityOfBirthName : undefined;
        data.data.personalData.countryOfBirth = data.data.personalData.countryOfBirth ?
            data.data.personalData.countryOfBirth : undefined;
        data.data.personalData.countryOfBirthName = data.data.personalData.countryOfBirthName ?
            data.data.personalData.countryOfBirthName : undefined;
        data.data.personalData.cpf = data.data.personalData.cpf ?
            data.data.personalData.cpf : undefined;
        data.data.personalData.dateOfBirth = data.data.personalData.dateOfBirth ?
            data.data.personalData.dateOfBirth : undefined;
        data.data.personalData.documentName = data.data.personalData.documentName ?
            data.data.personalData.documentName : undefined;
        data.data.personalData.documentNumber = data.data.personalData.documentNumber ?
            data.data.personalData.documentNumber : undefined;
        data.data.personalData.documentType = data.data.personalData.documentType ?
            data.data.personalData.documentType : undefined;
        data.data.personalData.documentTypeName = data.data.personalData.documentTypeName ?
            data.data.personalData.documentTypeName : undefined;
        data.data.personalData.editData = data.data.personalData.editData ?
            data.data.personalData.editData : [];
        data.data.personalData.email = data.data.personalData.email ?
            data.data.personalData.email : undefined;
        data.data.personalData.expeditionState = data.data.personalData.expeditionState ?
            data.data.personalData.expeditionState : undefined;
        data.data.personalData.expeditionStateName = data.data.personalData.expeditionStateName ?
            data.data.personalData.expeditionStateName : undefined;
        data.data.personalData.firstEdit = data.data.personalData.firstEdit ?
            data.data.personalData.firstEdit : [];
        data.data.personalData.gender = data.data.personalData.gender ?
            data.data.personalData.gender : undefined;
        data.data.personalData.genderCode = data.data.personalData.genderCode ?
            data.data.personalData.genderCode : undefined;
        data.data.personalData.genderName = data.data.personalData.genderName ?
            data.data.personalData.genderName : undefined;
        data.data.personalData.isCompleted = data.data.personalData.isCompleted ?
            data.data.personalData.isCompleted : undefined;
        data.data.personalData.issueDate = data.data.personalData.issueDate ?
            data.data.personalData.issueDate : undefined;
        data.data.personalData.issuingAgency = data.data.personalData.issuingAgency ?
            data.data.personalData.issuingAgency : undefined;
        data.data.personalData.issuingAgencyName = data.data.personalData.issuingAgencyName ?
            data.data.personalData.issuingAgencyName : undefined;
        data.data.personalData.motherName = data.data.personalData.motherName ?
            data.data.personalData.motherName : undefined;
        data.data.personalData.name = data.data.personalData.name ?
            data.data.personalData.name : undefined;
        data.data.personalData.nationality = data.data.personalData.nationality ?
            data.data.personalData.nationality : undefined;
        data.data.personalData.nationalityName = data.data.personalData.nationalityName ?
            data.data.personalData.nationalityName : undefined;
        data.data.personalData.phoneNumber = data.data.personalData.phoneNumber ?
            data.data.personalData.phoneNumber : undefined;
        data.data.personalData.photoDocument = data.data.personalData.photoDocument ?
            data.data.personalData.photoDocument : undefined;
        data.data.personalData.selfie = data.data.personalData.selfie ?
            data.data.personalData.selfie : undefined;
        data.data.personalData.uFOfBirth = data.data.personalData.uFOfBirth ?
            data.data.personalData.uFOfBirth : undefined;
        data.data.personalData.uFOfBirthName = data.data.personalData.uFOfBirthName ?
            data.data.personalData.uFOfBirthName : undefined;
        data.data.personalData.ufOfTheIssuingAgency = data.data.personalData.ufOfTheIssuingAgency ?
            data.data.personalData.ufOfTheIssuingAgency : undefined;

        data.data.maritalStatus.editData = data.data.maritalStatus.editData ?
            data.data.maritalStatus.editData : [];
        data.data.maritalStatus.firstEdit = data.data.maritalStatus.firstEdit ?
            data.data.maritalStatus.firstEdit : [];
        data.data.maritalStatus.foreignSpouse = data.data.maritalStatus.foreignSpouse ?
            data.data.maritalStatus.foreignSpouse : undefined;
        data.data.maritalStatus.isCompleted = data.data.maritalStatus.isCompleted ?
            data.data.maritalStatus.isCompleted : undefined;
        data.data.maritalStatus.maritalStatus = data.data.maritalStatus.maritalStatus ?
            data.data.maritalStatus.maritalStatus : undefined;
        data.data.maritalStatus.maritalStatusName = data.data.maritalStatus.maritalStatusName ?
            data.data.maritalStatus.maritalStatusName : undefined;
        data.data.maritalStatus.spouseCpf = data.data.maritalStatus.spouseCpf ?
            data.data.maritalStatus.spouseCpf : undefined;
        data.data.maritalStatus.spouseName = data.data.maritalStatus.spouseName ?
            data.data.maritalStatus.spouseName : undefined;

        data.data.address.adjunct = data.data.address.adjunct ?
            data.data.address.adjunct : undefined;
        data.data.address.city = data.data.address.city ?
            data.data.address.city : undefined;
        data.data.address.cityName = data.data.address.cityName ?
            data.data.address.cityName : undefined;
        data.data.address.district = data.data.address.district ?
            data.data.address.district : undefined;
        data.data.address.editData = data.data.address.editData ?
            data.data.address.editData : [];
        data.data.address.firstEdit = data.data.address.firstEdit ?
            data.data.address.firstEdit : [];
        data.data.address.isCompleted = data.data.address.isCompleted ?
            data.data.address.isCompleted : undefined;
        data.data.address.number = data.data.address.number ?
            data.data.address.number : undefined;
        data.data.address.postalCode = data.data.address.postalCode ?
            data.data.address.postalCode : undefined;
        data.data.address.state = data.data.address.state ?
            data.data.address.state : undefined;
        data.data.address.stateName = data.data.address.stateName ?
            data.data.address.stateName : undefined;
        data.data.address.street = data.data.address.street ?
            data.data.address.street : undefined;

        data.data.professionalData.editData = data.data.professionalData.editData ?
            data.data.professionalData.editData : [];
        data.data.professionalData.entityCnpj = data.data.professionalData.entityCnpj ?
            data.data.professionalData.entityCnpj : undefined;
        data.data.professionalData.entityThatWorks = data.data.professionalData.entityThatWorks ?
            data.data.professionalData.entityThatWorks : undefined;
        data.data.professionalData.firstEdit = data.data.professionalData.firstEdit ?
            data.data.professionalData.firstEdit : [];
        data.data.professionalData.isCompleted = data.data.professionalData.isCompleted ?
            data.data.professionalData.isCompleted : undefined;
        data.data.professionalData.originIncome = data.data.professionalData.originIncome ?
            data.data.professionalData.originIncome : undefined;
        data.data.professionalData.originIncomeName = data.data.professionalData.originIncomeName ?
            data.data.professionalData.originIncomeName : undefined;
        data.data.professionalData.profession = data.data.professionalData.profession ?
            data.data.professionalData.profession : undefined;
        data.data.professionalData.professionName = data.data.professionalData.professionName ?
            data.data.professionalData.professionName : undefined;

        data.data.incomeEquity.accessConditions = data.data.incomeEquity.accessConditions ?
            data.data.incomeEquity.accessConditions : undefined;
        data.data.incomeEquity.accountOpeningTerms = data.data.incomeEquity.accountOpeningTerms ?
            data.data.incomeEquity.accountOpeningTerms : undefined;
        data.data.incomeEquity.customerStatements = data.data.incomeEquity.customerStatements ?
            data.data.incomeEquity.customerStatements : undefined;
        data.data.incomeEquity.dateTaxResidency = data.data.incomeEquity.dateTaxResidency ?
            data.data.incomeEquity.dateTaxResidency : undefined;
        data.data.incomeEquity.declarationCustomerNotAuthorizeAttorney = data.data.incomeEquity.declarationCustomerNotAuthorizeAttorney ?
            data.data.incomeEquity.declarationCustomerNotAuthorizeAttorney : undefined;
        data.data.incomeEquity.editData = data.data.incomeEquity.editData ?
            data.data.incomeEquity.editData : [];
        data.data.incomeEquity.firstEdit = data.data.incomeEquity.firstEdit ?
            data.data.incomeEquity.firstEdit : [];
        data.data.incomeEquity.income = data.data.incomeEquity.income ?
            data.data.incomeEquity.income : undefined;
        data.data.incomeEquity.intermediationProposal = data.data.incomeEquity.intermediationProposal ?
            data.data.incomeEquity.intermediationProposal : undefined;
        data.data.incomeEquity.isCompleted = data.data.incomeEquity.isCompleted ?
            data.data.incomeEquity.isCompleted : undefined;
        data.data.incomeEquity.nif = data.data.incomeEquity.nif ?
            data.data.incomeEquity.nif : undefined;
        data.data.incomeEquity.noIncome = data.data.incomeEquity.noIncome ?
            data.data.incomeEquity.noIncome : undefined;
        data.data.incomeEquity.noPatrimony = data.data.incomeEquity.noPatrimony ?
            data.data.incomeEquity.noPatrimony : undefined;
        data.data.incomeEquity.patrimony = data.data.incomeEquity.patrimony ?
            data.data.incomeEquity.patrimony : undefined;
        data.data.incomeEquity.pep = data.data.incomeEquity.pep ?
            data.data.incomeEquity.pep : undefined;
        data.data.incomeEquity.personLinkedToTheBrokerage = data.data.incomeEquity.personLinkedToTheBrokerage ?
            data.data.incomeEquity.personLinkedToTheBrokerage : undefined;
        data.data.incomeEquity.purposeStatement = data.data.incomeEquity.purposeStatement ?
            data.data.incomeEquity.purposeStatement : undefined;
        data.data.incomeEquity.rulesAndParameters = data.data.incomeEquity.rulesAndParameters ?
            data.data.incomeEquity.rulesAndParameters : undefined;
        data.data.incomeEquity.taxResidence = data.data.incomeEquity.taxResidence ?
            data.data.incomeEquity.taxResidence : undefined;
        data.data.incomeEquity.taxResidenceName = data.data.incomeEquity.taxResidenceName ?
            data.data.incomeEquity.taxResidenceName : undefined;

        return data;
    }
}